import { render, staticRenderFns } from "./PageRowWrapper.vue?vue&type=template&id=6d0838cb&scoped=true"
import script from "./PageRowWrapper.vue?vue&type=script&lang=js"
export * from "./PageRowWrapper.vue?vue&type=script&lang=js"
import style0 from "./PageRowWrapper.vue?vue&type=style&index=0&id=6d0838cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0838cb",
  null
  
)

export default component.exports